import React, { useEffect, useState } from "react";
import { LogoutContactData, todayWorkflowContactData } from "../common/Helper";
import { useStateProvider } from "../common/StateProvider";
import TodayWorkflowItemProfile from "../dashboard/TodayWorkflowItemProfile";
import CancelDeleteModal from "../dashboard/CancelDeleteModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Tooltip, Button } from "@material-tailwind/react";

const LogoutContacts = () => {
  const { setTodaysWorkflowProfile, setTodaysWorkflowIndex } =
    useStateProvider(); // Get Profile
  const { deleteModal, setDeleteModal, setTodayWorkflowUpdate } =
    useStateProvider(); //DELETE MODEL
  const { deletModalHeading, setdeletModalHeading } = useStateProvider(); //DELETE MODEL HEADING
  const { profileItemPage, setProfileItemPage } = useStateProvider(); //TODAY WORKFLOW ITEM PROFILE PAGE
  const [todayWorkflowContactArray, setTodayWorkflowContactArray] = useState([
    ...LogoutContactData,
  ]);
  const [deleteItemIndex, setDeleteItemIndex] = useState(null);

  // Function to show the Productivity modal
  const opendeleteModal = (value, index) => {
    setDeleteModal(true);
    setdeletModalHeading(value.contactModeltext);
    setDeleteItemIndex(index); // Store the index
  };

  // Function to show the Today Workflow Item Profile Page
  const openProfileItemPage = (value, index) => {
    setProfileItemPage(true);
    setTodaysWorkflowProfile(value);
    setTodaysWorkflowIndex(index);
    setTodayWorkflowUpdate(todayWorkflowContactArray);
  };

  // OVERFLOW HIDDEN WHEN FILTER MODEL OPEN
  useEffect(() => {
    if (profileItemPage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [profileItemPage]);

  const deleteCard = () => {
    if (deleteItemIndex !== null) {
      const updatedData = [...todayWorkflowContactArray];
      updatedData.splice(deleteItemIndex, 1);
      setTodayWorkflowContactArray(updatedData);
      setDeleteModal(false); // Close the modal after deletion
    }
  };

  return (
    <>
      <div>
        <h4 className="text-sm sm:text-base 3xl:text-lg pb-3 md:pb-[26px] font-bold">
          Contact
        </h4>
        <div className="h-[calc(100vh-240px)] md:h-[calc(100vh-200px)] overflow-y-auto overflow_x_scroll_style ">
          {todayWorkflowContactArray.map((value, index) => (
            <div
              className="p-[13px_8px] cursor-pointer show-delete-btn hover:bg-[linear-gradient(90deg,_#F5F5F5_22.11%,_rgba(255,_255,_255,_0.00)_78.76%)] border-l-4 border-b-[0.2px] border-b-[#F2F2F2] border-transparent border-solid hover:border-l-primary bg-white duration-200 overflow-x-auto xs:overflow-x-hidden w-[400px] xs:w-auto"
              key={index}>
              <div className="flex items-center justify-between ">
                <div
                  onClick={() => openProfileItemPage(value, index)}
                  className="flex items-center gap-4 ">
                  <img src={value.logoutimg} alt="teams" />
                  <div>
                    <div className="flex items-center">
                      <h5 className="text-black text-sm 3xl:text-base font-normal">
                        {value.logoutheading}
                      </h5>
                      <button
                        className={`${value.LogoutBtnBgColor} text-black text-[10px] 3xl:text-xs rounded-[38px] px-2.5 py-1 bg-graf ml-2.5 font-normal`}>
                        {value.logoutbtn}
                      </button>
                      <Tooltip content="lorem ipsum" className="bg-primary">
                      <span className="pl-1 w-[15px] h-[15px]">{value.logoutErrorIcon}</span>
    </Tooltip>
                    </div>
                    <p className="text-[10px] 3xl:text-xs font-normal text-gray pt-1">
                      {value.logoutFollow}{" "}
                      <span className="text-primary">{value.logoutDate}</span>
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-[6px] cursor-pointer">
                  <span
                    className=" hidden logoutdelete-btn"
                    onClick={() => opendeleteModal(value, index)}>
                    {value.logoutdelete}
                  </span>
                  <span>{value.rightArrow}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        {deleteModal && (
          <CancelDeleteModal
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            deletModalHeading={deletModalHeading}
            deleteCard={deleteCard}
          />
        )}
      </div>
    </>
  );
};

export default LogoutContacts;
